class BestaOpeningFunctionComponent {
    constructor(openingFunction) {
        this.typeId = BestaOpeningFunctionComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = true;
        this.openingFunction = openingFunction;
    }
    eq() {
        return false;
    }
    toJson(parse) {
        return parse(JSON.stringify(this));
    }
    serializationKey() {
        return 'BestaOpeningFunctionComponent';
    }
}
BestaOpeningFunctionComponent.id = 2004;
export default BestaOpeningFunctionComponent;
//# sourceMappingURL=BestaOpeningFunctionComponent.js.map